module.exports = __webpack_public_path__ + "img/logo.f0cb3837.png";